import React from 'react';
import { Helmet } from 'react-helmet';
import useCanonicalUrl from '~/App/shared/hooks/useCanonicalUrl';

interface Props {
  pathname: string;
}

const CanonicalHeadLink = ({ pathname }: Props) => {
  const canonicalUrl = useCanonicalUrl(pathname);

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalHeadLink;
